import "./dashboard-card.scss";

import { DashboardModel } from "@shared/models/dashboard-model";
import classNames from "classnames";
import { memo } from "react";

export interface DashboardCardProps {
  model: DashboardModel;
  onClick?: (model: DashboardModel) => void;
}

export function DashboardCard({ model }: DashboardCardProps) {
  const { title, value, icon, description, iconClass } = model;
  return (
    <div id="DashboardCard" className="dashboard-card">
      <div className="flex justify-between border p-4 sm:p-6 rounded-lg">
        <div>
          <span className="block text-gray-500 text-xs sm:text-sm">
            {title}
          </span>
          <div className="text-900 font-medium text-lg sm:text-xl md:text-2xl">
            {value}
          </div>
        </div>
        <div
          className={classNames(
            "flex items-center justify-center rounded-lg p-2 sm:p-3 w-12 sm:w-14 md:w-16",
            iconClass
          )}
        >
          {icon}
        </div>
      </div>
      {description && (
        <span className="text-500 text-xs sm:text-sm">{description}</span>
      )}
    </div>
  );
}

// Memoized: the dashboard re-renders on every sidebar/dialog/pagination state
// change, and its card models are memoized, so unchanged cards can skip it.
export default memo(DashboardCard);
